export function beep(frequency = 520, duration = 0.25, volume = 0.4) {
	try {
		const ctx = new (window.AudioContext || window.webkitAudioContext)()
		const osc = ctx.createOscillator()
		const gain = ctx.createGain()
		osc.connect(gain)
		gain.connect(ctx.destination)
		osc.frequency.value = frequency
		gain.gain.setValueAtTime(volume, ctx.currentTime)
		gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + duration)
		osc.start(ctx.currentTime)
		osc.stop(ctx.currentTime + duration)
		osc.onended = () => ctx.close()
	} catch {
		// audio not available — fail silently
	}
}

